export default "__VITE_ASSET__D6NpPvr1__"